import { render, staticRenderFns } from "./sciencepropaganda.vue?vue&type=template&id=13a38b2a&scoped=true&"
import script from "./sciencepropaganda.vue?vue&type=script&lang=js&"
export * from "./sciencepropaganda.vue?vue&type=script&lang=js&"
import style0 from "./sciencepropaganda.vue?vue&type=style&index=0&id=13a38b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a38b2a",
  null
  
)

export default component.exports